@import "./helpers/scss-helper";

/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$businesscard-contact-padding-large-or-larger: 48px !default;
$businesscard-contact-padding-desktop: 40px !default;
$businesscard-contact-padding-tablet: 32px !default;
$businesscard-contact-padding-phone: 24px !default;
$businesscard-contact-padding-center-large-or-larger: 16px !default;
$businesscard-contact-padding-center-small: 12px !default;
$businesscard-contact-vertical-view-border-radius-content: 0 !default;
$businesscard-contact-vertical-view-offset-border-radius-content: 0 !default;
$businesscard-contact-vertical-view-offset-border-radius-image: 0 !default;
$businesscard-contact-horizontal-view-border-radius-content: 0 !default;
$businesscard-contact-horizontal-view-border-radius-image: 0 !default;
$businesscard-contact-vertical-view-box-shadow-content: none !default;
$businesscard-contact-vertical-view-offset-box-shadow-content: none !default;
$businesscard-contact-vertical-view-offset-box-shadow-image: none !default;
$businesscard-contact-horizontal-view-box-shadow-content: none !default;
$businesscard-contact-horizontal-view-box-shadow-image: none !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host([vertical="true"]) {
  display: flex;
}

* {
  margin: 0;
  padding: 0;
}

*,
*::after,
*::before {
  box-sizing: border-box;
  outline: 0 none;
  text-rendering: optimizelegibility;
}

.#{$prefix}card-background {
  display: block;
}

.#{$prefix}businesscard {
  display: grid;
  grid-template-rows: auto 1fr;

  .#{$prefix}card-content {
    background-color: v(backgroundColor);

    eon-ui-headline {
      --color: var(--textcolor) !important;
    }
  }

  &--left,
  &--center,
  &--right {
    &.#{$prefix}businesscard--vertical {
      &.#{$prefix}businesscard--no-offset {
        background-color: v(backgroundColor);
        @include borderRadius("vertical_view", "content");
        @include boxShadow("vertical_view", "content");
      }

      &.#{$prefix}businesscard--offset {
        .#{$prefix}businesscard__image--offset {
          z-index: 1;
          @include borderRadius("vertical_offset_view", "image");
          @include boxShadow("vertical_offset_view", "image");
        }

        .#{$prefix}card-content {
          @include borderRadius("vertical_offset_view", "content");
          @include boxShadow("vertical_offset_view", "content");
        }
      }

      &.#{$prefix}businesscard--no-image {
        .#{$prefix}businesscard__content--offset {
          @include for-size(desktop-l-or-larger) {
            padding: $businesscard-contact-padding-large-or-larger;
          }

          @include for-size(desktop) {
            padding: $businesscard-contact-padding-desktop;
          }

          @include for-size(tablet) {
            padding: $businesscard-contact-padding-tablet;
          }

          @include for-size(phone) {
            padding: $businesscard-contact-padding-phone;
          }
        }
      }
    }

    &.#{$prefix}businesscard--horizontal {
      .#{$prefix}businesscard__image--offset {
        z-index: 1;
        ::slotted([slot="image"]) {
          display: block;
          @include borderRadius("horizontal_view", "image");
          @include boxShadow("horizontal_view", "image");
        }
      }
      .#{$prefix}card-content {
        @include borderRadius("horizontal_view", "content");
        @include boxShadow("horizontal_view", "content");
      }
    }
  }

  &--left {
    .#{$prefix}businesscard__name,
    .#{$prefix}businesscard__info {
      text-align: left;
    }

    &.#{$prefix}businesscard--vertical {
      .#{$prefix}businesscard__content--offset {
        padding-top: #{$businesscard-contact-padding-large-or-larger * 2};

        @include for-size(desktop) {
          padding-top: #{$businesscard-contact-padding-desktop * 2}
        }

        @include for-size(tablet) {
          padding-top: #{$businesscard-contact-padding-tablet * 2}
        }

        @include for-size(phone) {
          padding-top: #{$businesscard-contact-padding-phone * 2}
        }
      }

      .#{$prefix}businesscard__image--offset {
        margin-bottom: -$businesscard-contact-padding-phone;
        margin-right: $businesscard-contact-padding-phone;

        @include for-size(tablet) {
          margin-bottom: -$businesscard-contact-padding-tablet;
          margin-right: $businesscard-contact-padding-tablet;
        }

        @include for-size(desktop) {
          margin-bottom: -$businesscard-contact-padding-desktop;
          margin-right: $businesscard-contact-padding-desktop;
        }

        @include for-size(desktop-l-or-larger) {
          margin-bottom: -$businesscard-contact-padding-large-or-larger;
          margin-right: $businesscard-contact-padding-large-or-larger;
        }
      }
    }

    &.#{$prefix}businesscard--horizontal {
      grid-template-columns: 30% 70%;
      grid-template-areas: "image content";

      .#{$prefix}businesscard__content--offset {
        padding-left: #{$businesscard-contact-padding-phone * 2};

        @include for-size(tablet) {
          padding-left: #{$businesscard-contact-padding-tablet * 2};
        }

        @include for-size(desktop) {
          padding-left: #{$businesscard-contact-padding-desktop * 2};
        }

        @include for-size(desktop-l-or-larger) {
          padding-left: #{$businesscard-contact-padding-large-or-larger * 2};
        }
      }

      .#{$prefix}businesscard__image--offset {
        margin-right: -$businesscard-contact-padding-phone;

        @include for-size(tablet) {
          margin-right: -$businesscard-contact-padding-tablet;
        }

        @include for-size(desktop) {
          margin-right: -$businesscard-contact-padding-desktop;
        }

        @include for-size(desktop-l-or-larger) {
          margin-right: -$businesscard-contact-padding-large-or-larger;
        }
      }
    }

    &.#{$prefix}businesscard--no-image {
      grid-template-columns: 100%;
      grid-template-areas: "content";
    }
  }

  &--center {
    &.#{$prefix}businesscard--vertical {
      .#{$prefix}businesscard__content--offset {
        padding-top: #{$businesscard-contact-padding-large-or-larger * 2};

        @include for-size(desktop) {
          padding-top: #{$businesscard-contact-padding-desktop * 2}
        }

        @include for-size(tablet) {
          padding-top: #{$businesscard-contact-padding-tablet * 2}
        }

        @include for-size(phone) {
          padding-top: #{$businesscard-contact-padding-phone * 2}
        }
      }

      .#{$prefix}businesscard__image--offset {
        margin-left: $businesscard-contact-padding-center-small;
        margin-right: $businesscard-contact-padding-center-small;

        @include for-size(phone) {
          margin-left: $businesscard-contact-padding-center-small;
          margin-right: $businesscard-contact-padding-center-small;
          margin-bottom: -$businesscard-contact-padding-phone;
        }

        @include for-size(tablet) {
          margin-bottom: -$businesscard-contact-padding-tablet;
        }

        @include for-size(desktop) {
          margin-bottom: -$businesscard-contact-padding-desktop;
        }

        @include for-size(desktop-l-or-larger) {
          margin-right: $businesscard-contact-padding-center-large-or-larger;
          margin-left: $businesscard-contact-padding-center-large-or-larger;
          margin-bottom: -$businesscard-contact-padding-large-or-larger;
        }
      }
    }

    &.#{$prefix}businesscard--horizontal {
      grid-template-columns: 30% 70%;
      grid-template-areas: "image content";

      .#{$prefix}businesscard__content--offset {
        padding-left: #{$businesscard-contact-padding-phone * 2};

        @include for-size(tablet) {
          padding-left: #{$businesscard-contact-padding-tablet * 2};
        }

        @include for-size(desktop) {
          padding-left: #{$businesscard-contact-padding-desktop * 2};
        }

        @include for-size(desktop-l-or-larger) {
          padding-left: #{$businesscard-contact-padding-large-or-larger * 2};
        }
      }

      .#{$prefix}businesscard__image--offset {
        margin-right: -$businesscard-contact-padding-phone;

        @include for-size(tablet) {
          margin-right: -$businesscard-contact-padding-tablet;
        }

        @include for-size(desktop) {
          margin-right: -$businesscard-contact-padding-desktop;
        }

        @include for-size(desktop-l-or-larger) {
          margin-right: -$businesscard-contact-padding-large-or-larger;
        }
      }
    }

    &.#{$prefix}businesscard--no-image {
      grid-template-columns: 100%;
      grid-template-areas: "content";
    }
  }

  &--right {
    .#{$prefix}businesscard__name,
    .#{$prefix}businesscard__info {
      text-align: right;
    }

    &.#{$prefix}businesscard--vertical {
      .#{$prefix}businesscard__content--offset {
        padding-top: #{$businesscard-contact-padding-large-or-larger * 2};

        @include for-size(desktop) {
          padding-top: #{$businesscard-contact-padding-desktop * 2}
        }

        @include for-size(tablet) {
          padding-top: #{$businesscard-contact-padding-tablet * 2}
        }

        @include for-size(phone) {
          padding-top: #{$businesscard-contact-padding-phone * 2}
        }
      }

      .#{$prefix}businesscard__image--offset {
        @include for-size(desktop-l-or-larger) {
          margin-left: $businesscard-contact-padding-large-or-larger;
          margin-bottom: -$businesscard-contact-padding-large-or-larger;
        }

        @include for-size(desktop) {
          margin-left: $businesscard-contact-padding-desktop;
          margin-bottom: -$businesscard-contact-padding-desktop;
        }

        @include for-size(tablet) {
          margin-left: $businesscard-contact-padding-tablet;
          margin-bottom: -$businesscard-contact-padding-tablet;
        }

        @include for-size(phone) {
          margin-left: $businesscard-contact-padding-phone;
          margin-bottom: -$businesscard-contact-padding-phone;
        }
      }
    }

    &.#{$prefix}businesscard--horizontal {
      grid-template-columns: 70% 30%;
      grid-template-areas: "content image";

      .#{$prefix}businesscard__content--offset {
        @include for-size(desktop-l-or-larger) {
          padding-right: #{$businesscard-contact-padding-large-or-larger * 2};
        }

        @include for-size(tablet) {
          padding-right: #{$businesscard-contact-padding-tablet * 2};
        }

        @include for-size(desktop) {
          padding-right: #{$businesscard-contact-padding-desktop * 2};
        }

        @include for-size(desktop-or-smaller) {
          padding-right: #{$businesscard-contact-padding-phone * 2};
        }
      }

      .#{$prefix}businesscard__image--offset {
        @include for-size(desktop-l-or-larger) {
          margin-left: -$businesscard-contact-padding-large-or-larger;
        }

        @include for-size(tablet) {
          margin-left: -$businesscard-contact-padding-tablet;
        }

        @include for-size(desktop) {
          margin-left: -$businesscard-contact-padding-desktop;
        }

        @include for-size(desktop-or-smaller) {
          margin-left: -$businesscard-contact-padding-phone;
        }
      }
    }
  }

  &--vertical {
    width: 100%;
    grid-template-columns: 100%;
    grid-template-areas:
      "image"
      "content";
  }

  &__content {
    grid-area: content;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    @include for-size(desktop-l-or-larger) {
      padding: $businesscard-contact-padding-large-or-larger;
    }

    @include for-size(desktop) {
      padding: $businesscard-contact-padding-desktop;
    }

    @include for-size(tablet) {
      padding: $businesscard-contact-padding-tablet;
    }

    @include for-size(phone) {
      padding: $businesscard-contact-padding-phone;
    }
  }

  &__image {
    grid-area: image;
  }

  &__name {
    display: block;
  }

  &__info {
    margin-top: 16px;
    display: block;
  }

  &__links {
    display: grid;
    grid-template-columns: 100%;
    row-gap: 10px;
    text-align: left;
  }
}

@include teaserCtaMargin(".#{$prefix}businesscard__links");

eon-ui-link {
  --contentHoverColor: var(--linkHoverColor) !important;
  --contentFocusColor: var(--textHoverColor) !important;
}